import { render, staticRenderFns } from "./history.vue?vue&type=template&id=4aadc1c1&scoped=true&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"
import style0 from "./history.vue?vue&type=style&index=0&id=4aadc1c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aadc1c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aadc1c1')) {
      api.createRecord('4aadc1c1', component.options)
    } else {
      api.reload('4aadc1c1', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=4aadc1c1&scoped=true&", function () {
      api.rerender('4aadc1c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/history.vue"
export default component.exports